
import Vue from 'vue'
import { SPECIALTIES_REF, arrayRef } from '@/models/refs'

export default Vue.extend({
    name: 'SpecialtySelector',
    props: ['values'],
    data() {
        return {
            selected: [] as string[],
            options: arrayRef(SPECIALTIES_REF),
        }
    },
    mounted() {
        this.selected = this.values
    },
    methods: {
        change() {
            this.$emit('onChange', this.selected as string[])
        },
    },
})
